import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar, Typography, Box } from '@mui/material';

export default function IntervenantsTable({ data }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f4f6f8' }}>
            <TableCell sx={{ fontWeight: 'bold' }}>Intervenant</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Commandes</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Ateliers</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>CA (€)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.intervenant_id} hover>
              <TableCell>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar sx={{ width: 32, height: 32, fontSize: '0.8rem' }}>{row.prenom[0]}</Avatar>
                  <Typography variant="body2" fontWeight="medium">{row.prenom} {row.nom}</Typography>
                </Box>
              </TableCell>
              <TableCell align="center">{row.kpis.orders}</TableCell>
              <TableCell align="center">{row.kpis.workshops}</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>{row.kpis.revenue} €</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}